import { Component, Input } from '@angular/core';
import { MaInsuranceExtendLife02InsRsk } from '@shared/models/ma-insurance-coverage-insurance';

@Component({
    selector: 'app-life02-ins-rsk',
    templateUrl: './life02-ins-rsk.component.html',
    styleUrls: ['./life02-ins-rsk.component.scss'],
    standalone: false
})
export class Life02InsRskComponent {
    @Input() maInsuranceExtend: MaInsuranceExtendLife02InsRsk;
}
